import {
    createContext
} from "react";
import type {
    ResizableContextType
} from "./type";

export const ResizableContext = createContext<ResizableContextType | undefined>(undefined);

export const ResizableIndexContext = createContext<number>(0);
